/**
 * The public site's address: where share links, og: tags and the link cards point.
 * The one default for the whole web package. Override it per build, never by editing
 * call sites:
 * - the SPA (share links, index.html's og:url / og:image): `VITE_SITE_URL` at build time
 *   (read in `env.ts` and in vite.config.ts for index.html);
 * - the OG worker (worker/app.ts): the `SITE_URL` var in wrangler.jsonc.
 * Moving to another domain is setting both, then a deploy.
 */
export const DEFAULT_SITE_URL = 'https://sparrowword.com';

/**
 * The site's old address (workers.dev), where players' data from before the move lives.
 * A page there hands it over to the site and redirects (src/pwa/move.ts); the Worker
 * marks it noindex and 301s bots (worker/hosts.ts). Override: `VITE_LEGACY_ORIGINS` for
 * the SPA and its service worker, `LEGACY_HOSTS` for the Worker.
 */
export const DEFAULT_LEGACY_ORIGIN = 'https://arrow-web.jcjmcclean.workers.dev';

/** `url` without trailing slashes, or the default when it's empty. */
export function siteUrl(url: string | undefined | null): string {
	return (url?.trim() || DEFAULT_SITE_URL).replace(/\/+$/, '');
}
